var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCounter4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 60,
    viewBox: "0 0 87 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6597 59C48.4535 59 62.0675 46.0163 62.0675 30C62.0675 13.9837 48.4535 1 31.6597 1C14.866 1 1.25195 13.9837 1.25195 30C1.25195 46.0163 14.866 59 31.6597 59Z",
    stroke: "#333939",
    strokeWidth: 1.18974,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7769 59C72.5707 59 86.1847 46.0163 86.1847 30C86.1847 13.9837 72.5707 1 55.7769 1C38.9832 1 25.3691 13.9837 25.3691 30C25.3691 46.0163 38.9832 59 55.7769 59Z",
    stroke: "#333939",
    strokeWidth: 1.18974,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.3691,
    y1: 30.5,
    x2: 62.0682,
    y2: 30.5,
    stroke: "#333939"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.3691,
    y1: 24.5,
    x2: 62.0682,
    y2: 24.5,
    stroke: "#333939"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 27.4648,
    y1: 18.5,
    x2: 59.9697,
    y2: 18.5,
    stroke: "#333939"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 32.709,
    y1: 11.5,
    x2: 54.7284,
    y2: 11.5,
    stroke: "#333939"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 26.416,
    y1: 36.5,
    x2: 61.018,
    y2: 36.5,
    stroke: "#333939"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 28.5137,
    y1: 42.5,
    x2: 58.9214,
    y2: 42.5,
    stroke: "#333939"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 32.709,
    y1: 48.5,
    x2: 54.7284,
    y2: 48.5,
    stroke: "#333939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter4);
export default __webpack_public_path__ + "static/media/counter-4.b81068e933b0ac04effffd2887517d51.svg";
export { ForwardRef as ReactComponent };